import React, { createRef } from 'react';
import { IonInput, IonChip, IonSearchbar, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/HelpOverlay.scss';
import ArrowImg from '../images/arrow.svg';

import ArrowWhiteImg from '../images/white-arrow.svg';
import ShakeLogo from '../images/shake.svg'
import ArrowBlueImg from '../images/blue-arrow.svg';
import { closeCircle, closeSharp } from 'ionicons/icons';

export class ArrowComponent extends React.Component {
    render() {
        return (
            <div 
                className="arrow-wrapper"
                style={this.props.style}
                data-direction={this.props.direction}
            >
                <img src={this.props.blueArrow ? ArrowBlueImg : ArrowWhiteImg} />
                <label
                    style={this.props.styleLabel || {}}
                >{this.props.text}</label>
            </div>
        )
    }
}

class HelpOverlay extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        document.body.classList.add("help-overlay-showing");
    }

    componentWillUnmount() {
        document.body.classList.remove("help-overlay-showing");
    }

    render() {

        // return null;

        return (
            <div 
                className="help-overlay"
                id="help-overlay"
                data-view={this.props.view}
                onClick={() => {
                    localStorage.setItem("help-overlay-hidden-" + this.props.view, true)
                    this.props.close();
                }}
            >
                <button>
                    <IonIcon icon={closeSharp} />
                </button>
                {/* <div className="shake">
                    <img src={ShakeLogo} />
                    <span>Shake any time on this page to see this guide again</span>
                </div> */}
            </div>
        );
    }

};


export default withIonLifeCycle(HelpOverlay);
